import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import NavBar from "components/NavBar/NavBar";
import Users from "pages/Users/Users";
import Home from "pages/Home/Home";
import UserCreate from "pages/Users/UserCreate/UserCreate";
import UserEdit from "pages/Users/UserEdit/UserEdit";
import Groups from "pages/Groups/Groups";
import GroupCreate from "pages/Groups/GroupsCreate/GroupCreate";
import GroupEdit from "pages/Groups/GroupsEdit/GroupEdit";
import UsersSurvey from "pages/Survey/UsersSurvey";
import UserSurveyCreate from "pages/Survey/UserSurveyCreate/UserSurveyCreate";
import UserSurveyEdit from "pages/Survey/UserSurveyEdit/UserSurveyEdit";
import Survey from "pages/SurveyForm/Survey";
import Employees from "pages/Reports/Employees";
import Relatives from "pages/Reports/Relatives";
import Children from "pages/Reports/Children";
import FileHistory from "pages/File/FileHistory";
import FileDetail from "pages/File/FileDetail";

const Layout = ({ pca }: any) => {
  return (
    <MsalProvider instance={pca}>
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route index element={<Home />} />
          <Route path='admin'>
            <Route path='users' element={<Users />} />
            <Route path='user-create' element={<UserCreate />} />
            <Route path='user-edit/:userId' element={<UserEdit />} />
            <Route path='roles' element={<Groups />} />
            <Route path='group-create' element={<GroupCreate />} />
            <Route path='group-edit/:groupId' element={<GroupEdit />} />
          </Route>
          <Route path='survey'>
            <Route path='answer' element={<Survey />} />
            <Route path='send' element={<UsersSurvey />} />
            <Route path='user-create' element={<UserSurveyCreate />} />
            <Route path='user-edit/:userId' element={<UserSurveyEdit />} />
            <Route path='file-history' element={<FileHistory />} />
            <Route path='file-detail' element={<FileDetail />} />
          </Route>
          <Route path='reports'>
            <Route path='datasheetemployees' element={<Employees />} />
            <Route path='datasheetchildren' element={<Children />} />
            <Route path='datasheetrelatives' element={<Relatives />} />
          </Route>
          <Route path='*' element={<Navigate replace to='/' />} />
        </Routes>
      </BrowserRouter>
    </MsalProvider>
  );
};

export default Layout;
